"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSystemError = void 0;
/**
 * Type guard NodeJS SystemErrors.
 * The list is not complete. Will add as needed.
 * Feel free to contribute.
 */
function isSystemError(code, err) {
    return !!err && err.code === code;
}
exports.isSystemError = isSystemError;
//# sourceMappingURL=isNodeError.js.map